import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/mock';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Check URL parameter for initial language
  const getInitialLanguage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    if (langParam === 'zh' || langParam === 'cn' || langParam === 'chinese') {
      return 'zh';
    }
    if (langParam === 'en' || langParam === 'english') {
      return 'en';
    }
    // Check localStorage for saved preference
    const saved = localStorage.getItem('preferred_language');
    if (saved === 'zh' || saved === 'en') {
      return saved;
    }
    return 'en';
  };

  const [language, setLanguage] = useState(getInitialLanguage);

  // Save language preference to localStorage
  useEffect(() => {
    localStorage.setItem('preferred_language', language);
  }, [language]);

  const t = translations[language];

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'zh' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
